import { CloseOutlined } from "@ant-design/icons"
import { Button, Modal, Form, Input, Select, DatePicker, ConfigProvider, Radio, TimePicker, Checkbox, TreeSelect, } from "antd"

import viVN from 'antd/locale/vi_VN';

import '../../../../styles.scss'
import { dataInteractionCategory, dataInteractionCategory_V2, dataInteractionType } from "../../../../../../services/data";
import React, { useEffect, useState } from "react";
import useToast from "../../../../../../hook/useToast";
import useLoading from "../../../../../../hook/useLoading";
import { useSelector } from "react-redux";
import { selectorInfoUser } from "../../../../../../store/slices/infoUserSlice";
import { getSLProfitCenterName, getSLVehicleEngineNos, ISelectOption } from "../../../../../../api/selectOptions/selectOptionsApi";
import { convertToAntdOptions, fommatSelectOption, fommatSelectOptionToUpperCase, fommatSelectOptionUnitByUser, formatIssuingUnitTree } from "../../../../../../until";
import dayjs from "dayjs";
import { getSLCarsByCarLineIdAndCategoryCarId, getSLVehicleChassisNumbers, getSLVehiclePlateNumbers, ICarForInfomation } from "../../../../../../api/selectOption/selectOptionsApi";
import { getListIssuingUnit, IIssuingUnit } from "../../../../../../api/unit/unitApi";
import { FormProps } from "antd/lib";
import useThrottle from "../../../../../../hook/useThrottle";
import { addRepairAppointment } from "../../../../../../api/Customer_V2/customerApi_V2";
import { selectorUnitByUserPermission } from "../../../../../../store/slices/UnitByUserPermission";
import useDebounce from "../../../../../../hook/useDebounce";
import { getInfoCarCustomer } from "../../../../../../api/car/carApi";

const { TextArea } = Input;

interface ModalProps {
    isOpen: boolean
    idCustomer?: number
    resultFormSubmit?: (iSsuccess: boolean, message?: string) => void
    closeModal: (isOpen: boolean) => void
}
const ModalSalesAndServiceScheduleARepairAddV2: React.FC<ModalProps> = ({
    isOpen, idCustomer,
    resultFormSubmit, closeModal
}) => {

    const pushToast = useToast()
    const pushLoading = useLoading()
    const { id, username, unit } = useSelector(selectorInfoUser)
    const unitByUserPermissionSlice = useSelector(selectorUnitByUserPermission)

    const [form] = Form.useForm();

    const registrationDate = Form.useWatch("registrationDate", form); // ngày ghi nhận

    const vehicleId = Form.useWatch("vehicleId", form); // tên xe
    const chassisNo = Form.useWatch("chassisNo", form); // số khung
    const engineNo = Form.useWatch("engineNo", form); // số máy

    const tentativeRegistrationDate = Form.useWatch("tentativeRegistrationDate", form); // Ngày hẹn sửa chữa
    const vehicleBookingEffectiveGetDate = Form.useWatch("vehicleBookingEffectiveGetDate", form); // Ngày bắt đầu sửa chữa

    const isArrive = Form.useWatch("isArrive", form); // Khách đến xưởng


    const [sLProfitCenterName, setSLProfitCenterName] = useState<ISelectOption[]>([])
    const [sLCarId, setSLCarId] = useState<any[]>([])
    // const [sLNumberPlateId, setSLNumberPlateId] = useState<ISelectOption[]>([])
    const [sLChassisNo, setSLChassisNo] = useState<ISelectOption[]>([])
    const [sLEngineNo, setSLEngineNo] = useState<ISelectOption[]>([])

    const [sLAdminId, setSLAdminId] = useState<ISelectOption[]>([{ value: id, label: username }])
    const [sLBranchId, setSLBranchId] = useState<ISelectOption[]>([])
    const [searchCar, setSearchCar] = useState<string>('')


    const [carId, setCarId] = useState<number>()
    const [plateNumberId, setPlateNumberId] = useState<number>()

    //#region gọi api SL OP
    // Loại hình dịch vụ
    const gSLProfitCenterName = async () => {
        if (!idCustomer) return
        const result = await getSLProfitCenterName(

        )
        if (result?.status) {
            setSLProfitCenterName(fommatSelectOption(result.data))
        }
    }

    // tên xe
    const gSLCarId = useDebounce(async () => {
        if (!idCustomer) return
        const result = await getSLCarsByCarLineIdAndCategoryCarId(
            idCustomer, undefined, undefined, searchCar
        )
        if (result?.status) {
            setSLCarId(convertToAntdOptions(result.data))

            const allChildren = result?.data?.flatMap(g => g.children || []) || [];
            if (allChildren.length === 1) {
                form.setFieldValue("vehicleId", allChildren[0].vehicleId); //rs tên xe
            }
        }
    }, 1000)


    const gInfoCarCustomer = useDebounce(async () => {
        if (!idCustomer || !vehicleId) return
        const result = await getInfoCarCustomer(
            vehicleId, idCustomer
        )
        if (result?.status) {
            const { plateNumber, plateNumberId, vehicleChassisNo } = result.data
            setSLChassisNo(fommatSelectOptionToUpperCase(vehicleChassisNo))
            setPlateNumberId(plateNumberId)
            form.setFieldValue("numberPlateId", plateNumber);
            if (vehicleChassisNo.length === 1)
                form.setFieldValue("chassisNo", vehicleChassisNo[0].id);
        }
    }, 1000)

    // số máy
    const gSLEngineNo = async () => {
        if (!idCustomer) return
        if (!vehicleId) {
            setSLEngineNo([])
            return
        }
        const result = await getSLVehicleEngineNos(
            idCustomer, vehicleId,
        )
        if (result?.status) {
            setSLEngineNo(fommatSelectOptionToUpperCase(result.data))

            if (result.data.length === 1) {
                const { id } = result.data[0]
                form.setFieldValue("engineNo", id); // Số máy
            }
        }
    }

    //dơn vị
    const gSLBranchId = async () => {
        setSLBranchId(fommatSelectOptionUnitByUser(unitByUserPermissionSlice))
    }
    //#endregion

    const onFinish: FormProps["onFinish"] = useThrottle(async (values: any) => {

        if (!idCustomer) return
        pushLoading(true)
        const {
            vehicleBookingDocCode, registrationDate, tentativeRegistrationDate,
            registrationTime,
            contactType, profitCenterName, vehicleId,
            chassisNo, engineNo, adminId, cabinNo,
            vehicleBookingEffectiveGetDate, vehicleBookingEffectiveGetTime, branchId, routeId,
            tentativeCustomerRequest, isArrive, dungHen, saiHen
        } = values

        const registrationDateTmp = registrationDate ? registrationDate?.format('YYYY/MM/DD') : undefined
        const tentativeRegistrationDateTmp = tentativeRegistrationDate ? tentativeRegistrationDate?.format('YYYY/MM/DD') : undefined
        const registrationTimeTmp = registrationTime ? registrationTime?.format('HH:mm') : undefined
        const vehicleBookingEffectiveGetDateTmp = vehicleBookingEffectiveGetDate ? vehicleBookingEffectiveGetDate?.format('YYYY/MM/DD') : undefined
        const vehicleBookingEffectiveGetTimeTmp = vehicleBookingEffectiveGetTime ? vehicleBookingEffectiveGetTime?.format('HH:mm') : undefined
        // const carIdTmp = carId ? carId : undefined

        const result = await addRepairAppointment(
            idCustomer, vehicleBookingDocCode, registrationDateTmp,
            tentativeRegistrationDateTmp, registrationTimeTmp, contactType, profitCenterName,
            carId, vehicleId, plateNumberId, chassisNo, engineNo,
            adminId, cabinNo, vehicleBookingEffectiveGetDateTmp, vehicleBookingEffectiveGetTimeTmp,
            branchId, routeId, tentativeCustomerRequest, isArrive,
            dungHen, saiHen
        )
        if (result?.status) {
            resultFormSubmit?.(true, result?.message)
        } else {
            resultFormSubmit?.(false, result?.message)
        }
        pushLoading(false)

    }, 2000)

    //#region Thay đổi form rs 
    useEffect(() => {
        if (!isOpen) return
        if (vehicleId) {
            gInfoCarCustomer()
        } else {
            form.setFieldsValue({
                "numberPlateId": undefined,
                "chassisNo": undefined,
                "engineNo": undefined
            })

            setSLChassisNo([])
            setSLEngineNo([])
        }
        // if (isProgrammaticCarLineSet.current) {
        //   isProgrammaticCarLineSet.current = false;
        //   return;
        // }
        if (isOpen) {
            form.setFieldValue("numberPlateId", undefined); //rs  biển số xe
            form.setFieldValue("chassisNo", undefined); //rs Số khung (VIN)
            form.setFieldValue("engineNo", undefined); //rs bSố máy
        }
    }, [vehicleId]);


    useEffect(() => {
        if (!isOpen) return

        gSLEngineNo()
        // if (isProgrammaticCarLineSet.current) {
        //   isProgrammaticCarLineSet.current = false;
        //   return;
        // }
        if (isOpen) {
            form.setFieldValue("engineNo", undefined); //rs bSố máy
        }
    }, [chassisNo]);

    useEffect(() => {
        if (!isOpen) return

        if (isOpen) {
            if (vehicleBookingEffectiveGetDate)
                form.setFieldValue("isArrive", true); //rs tự check Khách hàng đã đến xưởng khi vehicleBookingEffectiveGetDate
        }
    }, [vehicleBookingEffectiveGetDate]);

    useEffect(() => {
        if (!isOpen) return

        if (isOpen) {
            form.setFieldValue("dungHen", false); //rs dungHen
            form.setFieldValue("saiHen", false); //rs saiHen
        }
    }, [isArrive]);

    //#endregion

    useEffect(() => {
        if (isOpen)
            gSLCarId()
    }, [searchCar])


    useEffect(() => {
        if (isOpen) {
            if (!sLProfitCenterName.length)
                gSLProfitCenterName()
            // if (!sLCarId.length) //issue UAT_497 yêu cầu sau khi mở modal thì ơhair set giá trị ban đầu, nên phải gọi api để tránh reset
            gSLCarId()
            if (!sLBranchId.length)
                gSLBranchId()

            form.setFieldsValue({
                adminId: id,
                branchId: unit,
                registrationDate: dayjs(),
                tentativeRegistrationDate: dayjs(),
                registrationTime: dayjs().startOf("minute"),
                vehicleBookingDocCode: "S1"
            });
        } else {
            form.resetFields()
        }

    }, [isOpen])
    return (
        <Form
            form={form}
            layout="vertical"
            className=" "
            onFinish={onFinish}
        >
            <ConfigProvider locale={viVN}>
                <Modal
                    title={<div className="bg-FCFCFD d-flex justify-betweeen align-center pb-4  w-full border-b-F0F0F0 rounded-2 overflow-hidden">
                        <span className="text-base text-344054 fw-500 font-medium">Tạo đặt lịch hẹn sửa chữa</span>
                        <CloseOutlined className="text-base text-8B8B8B" onClick={() => closeModal(false)} />
                    </div>}
                    open={isOpen}
                    onCancel={() => closeModal(false)}
                    centered
                    className="custom-modal-ant-history"
                    destroyOnClose
                    closeIcon={false}
                    footer={<div className="bg-FCFCFD d-flex justify-betweeen align-center pt-2  w-full border-t-F0F0F0">
                        <div className="custom-page-css w-full flex justify-end gap-2 mt-4">
                            <Button onClick={() => closeModal(false)}>Huỷ</Button>
                            <Button
                                type="primary"
                                onClick={() => form.submit()}
                            >Lưu</Button>
                        </div>
                    </div>}
                >
                    <div className="custom-modal-ant-history-child custom-page-css flex flex-col max-h-65vh overflow-y-scroll gap-2 py-2">
                        <span className="text-base text-344054 fw-500 font-medium">Thông tin chung</span>
                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item
                                label={<span>
                                    Loại tương tác <span className="text-FF1D1D">*</span>:
                                </span>}
                                name="vehicleBookingDocCode"
                                rules={[
                                    { required: true, message: "Vui lòng loại tương tác" },
                                ]}
                                layout="vertical"
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Loại tương tác"
                                    disabled
                                    // options={dataInteractionType}
                                    options={dataInteractionCategory_V2}
                                />
                            </Form.Item>

                            <Form.Item
                                label="Phân loại liên hệ:"
                                name="contactType"
                                layout="vertical"
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Phân loại liên hệ"
                                    options={dataInteractionCategory}
                                />
                            </Form.Item>
                        </div>
                        {/* Row 1 */}
                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item
                                label={
                                    <span>Ngày ghi nhận <span className="text-FF1D1D">*</span>:</span>
                                }
                                name="registrationDate"
                                layout="vertical"
                                rules={[
                                    { required: true, message: "Vui lòng ngày ghi nhận" },
                                ]}
                            >
                                <DatePicker className="w-full custom-input-date" format="DD/MM/YYYY" />
                            </Form.Item>

                            <Form.Item
                                label="Tên Hợp đồng kinh doanh:"
                                name="profitCenterName"
                                layout="vertical"
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Tên Hợp đồng kinh doanh"
                                    options={sLProfitCenterName}
                                />
                            </Form.Item>
                        </div>

                        <span className="text-base text-344054 fw-500 font-medium pt-2">Thông tin xe</span>
                        {/* Row 3 */}
                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item name='carId' hidden></Form.Item>
                            <Form.Item
                                layout="vertical"
                                label={<span>
                                    Tên xe <span className="text-FF1D1D">*</span>:
                                </span>}
                                name="vehicleId"
                                rules={[
                                    { required: true, message: "Vui lòng chọn tên xe" },
                                ]}
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Tên xe"
                                    showSearch
                                    searchValue={searchCar}
                                    onSearch={(e) => setSearchCar(e)}
                                    filterOption={false}
                                    allowClear
                                    onChange={(value, option: any) => {
                                        setCarId(option?.carId)
                                    }}
                                    options={sLCarId}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Biển số xe:"
                                name="numberPlateId"
                                layout="vertical"
                            >
                                <Input
                                    className="custom-page-css border rounded"
                                    placeholder="Biển số xe"
                                    disabled
                                />
                            </Form.Item>
                        </div>
                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item
                                label="Số khung:"
                                name="chassisNo"
                                layout="vertical"
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Số khung"
                                    disabled={!vehicleId}
                                    options={sLChassisNo}
                                />
                            </Form.Item>

                            <Form.Item
                                label="Số máy:"
                                name="engineNo"
                                layout="vertical"
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Số máy"
                                    disabled={!chassisNo}
                                    options={sLEngineNo}
                                />
                            </Form.Item>
                        </div>
                        <span className="text-base text-344054 fw-500 font-medium pt-2">Thông tin lịch hẹn</span>

                        {/* Row 4 */}
                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item
                                label="Nhân viên tiếp nhận:"
                                name="adminId"
                                layout="vertical"
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Nhân viên tiếp nhận"
                                    disabled
                                    options={sLAdminId}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Khoang:"
                                name="cabinNo"
                                layout="vertical"
                            >
                                <Input
                                    className="custom-page-css border rounded custom-input-css"
                                    placeholder="Khoang " />
                            </Form.Item>
                        </div>
                        <div className="custom-page-css grid grid-cols-2 gap-6">
                            {/* Ngày hẹn đến sửa */}
                            <div className="custom-page-css flex flex-col gap-2">
                                <label className="text-sm text-gray-800">
                                    Ngày hẹn đến sửa <span className="text-FF1D1D">*</span>:
                                </label>

                                <div className="custom-page-css grid grid-cols-2 gap-3">
                                    <Form.Item
                                        name="tentativeRegistrationDate"
                                        rules={[
                                            { required: true, message: "Vui lòng chọn ngày hẹn đến sửa" },
                                        ]}
                                        layout="vertical"
                                    >
                                        <DatePicker
                                            placeholder="Chọn ngày"
                                            className="w-full custom-input-date"
                                            format="DD/MM/YYYY"
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="registrationTime"
                                        rules={[
                                            { required: true, message: "Vui lòng chọn ngày hẹn đến sửa" },
                                        ]}
                                        layout="vertical"
                                    >
                                        <TimePicker
                                            placeholder="Chọn giờ"
                                            className="w-full custom-input-date"
                                            format="HH:mm"
                                            disabled={!tentativeRegistrationDate}
                                        />
                                    </Form.Item>
                                </div>
                            </div>

                            {/* Ngày bắt đầu sửa chữa */}
                            <div className="custom-page-css flex flex-col gap-2">
                                <label className="text-sm text-gray-800">
                                    Ngày bắt đầu sửa chữa:
                                </label>

                                <div className="custom-page-css grid grid-cols-2 gap-3">
                                    <Form.Item
                                        name="vehicleBookingEffectiveGetDate"
                                    >
                                        <DatePicker
                                            placeholder="Chọn ngày"
                                            className="w-full custom-input-date"
                                            format="DD/MM/YYYY"
                                        />
                                    </Form.Item>


                                    <Form.Item
                                        name="vehicleBookingEffectiveGetTime"
                                        dependencies={[
                                            "vehicleBookingEffectiveGetDate",
                                            "tentativeRegistrationDate",
                                            "registrationTime",
                                        ]}
                                        rules={[
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    const startDate =
                                                        getFieldValue(
                                                            "vehicleBookingEffectiveGetDate"
                                                        );
                                                    const tentativeDate =
                                                        getFieldValue(
                                                            "tentativeRegistrationDate"
                                                        );
                                                    const tentativeTime =
                                                        getFieldValue("registrationTime");

                                                    // TH1: có ngày bắt đầu sửa → giờ bắt buộc
                                                    if (startDate && !value) {
                                                        return Promise.reject(
                                                            new Error(
                                                                "Vui lòng chọn giờ bắt đầu sửa chữa"
                                                            )
                                                        );
                                                    }

                                                    // TH2: so sánh datetime
                                                    if (
                                                        startDate &&
                                                        value &&
                                                        tentativeDate &&
                                                        tentativeTime
                                                    ) {
                                                        const startDateTime = startDate
                                                            .hour(value.hour())
                                                            .minute(value.minute());

                                                        const tentativeDateTime = tentativeDate
                                                            .hour(tentativeTime.hour())
                                                            .minute(tentativeTime.minute());

                                                        if (
                                                            startDateTime.isBefore(
                                                                tentativeDateTime
                                                            )
                                                        ) {
                                                            return Promise.reject(
                                                                new Error(
                                                                    "Ngày bắt đầu sửa chữa phải lớn hơn hoặc bằng ngày hẹn đến sửa"
                                                                )
                                                            );
                                                        }
                                                    }

                                                    return Promise.resolve();
                                                },
                                            }),
                                        ]}
                                    >
                                        <TimePicker
                                            placeholder="Chọn giờ"
                                            className="w-full custom-input-date"
                                            format="HH:mm"
                                            disabled={!vehicleBookingEffectiveGetDate}
                                        />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>

                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item
                                label="Đơn vị:"
                                name="branchId"
                                layout="vertical"
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Đơn vị"
                                    options={sLBranchId}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Điểm bán hàng:"
                                name="routeId"
                                layout="vertical"
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Điểm bán hàng"
                                    options={sLBranchId}
                                />
                            </Form.Item>
                        </div>

                        <Form.Item
                            label="Yêu cầu khách hàng:"
                            name="tentativeCustomerRequest"
                            layout="vertical"
                        >
                            <TextArea
                                rows={4}
                                placeholder="Nhập yêu cầu khách hàng"
                            />
                        </Form.Item>

                        <Form.Item
                            name="isArrive"
                            valuePropName="checked"
                        >
                            <Checkbox
                            >Khách hàng đến xưởng
                            </Checkbox>
                        </Form.Item>

                        <Form.Item
                            name="dungHen"
                            valuePropName="checked"
                            className="custom-checkbox-to-radio"
                        >
                            <Checkbox
                                disabled={!isArrive}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        form.setFieldValue("saiHen", false);
                                    }
                                }}
                            >Đúng hẹn
                            </Checkbox>
                        </Form.Item>
                        <Form.Item
                            name="saiHen"
                            valuePropName="checked"
                            className="custom-checkbox-to-radio"
                        >
                            <Checkbox
                                disabled={!isArrive}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        form.setFieldValue("dungHen", false);
                                    }
                                }}
                            >Sai hẹn
                            </Checkbox>
                        </Form.Item>
                    </div>
                </Modal>
            </ConfigProvider>
        </Form>
    )
}
export default ModalSalesAndServiceScheduleARepairAddV2
